import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DropdownOption } from '@hs/ui-core-common';
import { SingleSelectDropdownComponent } from '@hs/ui-core-dropdowns';
import { ButtonComponent, TextareaComponent, TextInputComponent } from '@hs/ui-core-inputs';

import { ButtonLabel, DashboardNote, SaveDashboardNote } from '../../../models/dashboard-note';

@Component({
    selector: 'ddv-dashboard-note-edit',
    templateUrl: 'edit-dashboard-note.component.html',
    styleUrls: ['edit-dashboard-note.component.scss'],
    imports: [
        SingleSelectDropdownComponent,
        TextInputComponent,
        TextareaComponent,
        ButtonComponent,
    ],
})
export class EditDashboardNoteComponent implements OnChanges {
    @Input() note: DashboardNote | undefined;

    @Output() cancelEdit = new EventEmitter<void>();
    @Output() deleteNote = new EventEmitter<void>();
    @Output() saveNote = new EventEmitter<SaveDashboardNote>();

    protected buttonLabelOptions: DropdownOption[] = [
        { text: 'Disclaimer', value: 'disclaimer' },
        { text: 'View Notes', value: 'notes' },
    ];
    protected buttonLabel: DropdownOption | undefined;
    protected isEditingExistingNote = false;
    protected title: string | undefined;
    protected message: string | undefined;

    ngOnChanges(): void {
        this.isEditingExistingNote = !!this.note;
        this.populateForm();
    }

    protected onDelete(): void {
        this.deleteNote.emit();
    }

    protected onCancel(): void {
        this.cancelEdit.emit();
    }

    protected onSave(): void {
        if (this.buttonLabel && this.title && this.message) {
            this.saveNote.emit({
                dashboardNote: {
                    buttonLabel: this.buttonLabel.text as ButtonLabel,
                    title: this.title,
                    message: this.message,
                },
                status: this.isEditingExistingNote ? 'update' : 'new',
            });
        }
    }

    private populateForm(): void {
        if (this.note) {
            this.buttonLabel = this.buttonLabelOptions.find((option) => option.text === this.note?.buttonLabel);
            this.title = this.note.title;
            this.message = this.note.message;
        }
    }
}
